import { connect } from 'react-redux';
import { withProps, withPropsOnChange, compose, withState, withHandlers, lifecycle } from 'recompose';

import { getCustomerName, getCustomerId } from '../../customer/selectors';
import { resetCustomer, setCustomer } from '../../customer/actions';
import withFetchCustomerResults from '../../../common/hoc/withFetchCustomerResults';
import CustomerSelect from '../components/CustomerSelect';
import withPermissions from '../../../auth/utils/withPermissions';

const CustomerSelectContainer = compose(
  withFetchCustomerResults,
  withPermissions,
  connect(
    state => ({
      selectedCustomer: getCustomerId(state),
      customerName: getCustomerName(state, getCustomerId(state)),
    }),
    { setCustomer, resetCustomer },
  ),
  lifecycle({
    componentDidMount() {
      this.props.clearResults();
    },
  }),
  withState('value', 'setValue', ''),
  withHandlers({
    fetchResults: props => value => props.fetchCustomerResults(value),
  }),
  withHandlers({
    onBlur: props => () => {
      props.clearResults();
      props.setValue('');
    },
    selectCustomer: props => customer => () => {
      props.clearResults();
      return props.setCustomer(customer);
    },
    unselectCustomer: props => () => {
      props.setValue('');
      props.clearResults();
      return props.resetCustomer();
    },
  }),
  withPropsOnChange(['customerName'], (props) => {
    props.setValue(props.customerName);
  }),
  withProps(props => ({
    results: (props.value && !props.selectedCustomer) ? props.results : [],
  })),
)(CustomerSelect);

export default CustomerSelectContainer;
